import React, { Component } from 'react';
import { Card, Navbar} from 'react-bootstrap';
import '../App.css'
import '../fontello/css/fontello.css';

class SideNavComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
        }
    }
    render() {
        return (
            <div>
                <Navbar bg="primary" variant="dark">
                    <Navbar.Brand>{this.state.data.User}</Navbar.Brand>
                </Navbar>
                <div className="p-3 text-center">
                    <img
                        width="200px"
                        src={this.state.data.Photo}
                        alt="Avatar" />
                </div>
                <div className="text-right pr-5">
                    <b>
                    {this.state.data.Loc}  
                    </b>
                </div>                
                <Card>
                    <Card.Header>About Me</Card.Header>
                    <Card.Body>
                        <Card.Text className="text-center">
                        <div dangerouslySetInnerHTML={{ __html: this.state.data.AboutMe   }}></div>
                    </Card.Text>
                    </Card.Body>
                </Card>
                <div className="text-center p-1">
                    {
                        this.state.data.socialLinks.map(item =>{
                            return(

                                <a href={item.url} className="px-1">
                                    <i className={item.className} />
                                </a>
                            )
                        })
                    }
                </div>

                
            </div>
        )
    }
}

export default SideNavComponent;